/* eslint-disable no-console */
import React, { useState, createContext } from 'react'
import {
  httpAxios,
  navigateToExternalLink,
  convertToSafariCompatibleDate,
  makeArrayUnique,
  checkUserLogin
} from 'AccountsUtils'
import {
  POST_CALL,
  FETCH_TRIPS_URL,
  POLL_STATUS,
  GET_CALL
} from 'AccountsConstants/api_endpoints'
import { UNAUTHORIZED_REDIRECT } from 'AccountsConstants/routes'
import { getMappedValue } from '../../utils/arabicUtils'

export const TripListContext = createContext({
  trips: [],
  fetchAllTrips: () => { },
  tripsLoading: false,
  tripsLoadingFailed: false,
  upcomingTripsCount: 0,
  updateTripsHandler: () => { },
})

export const TripState = ({ children }) => {
  const [trips, updateTripsHandler] = useState([])
  const [upcomingTripsCount, upcomingTripsCountHandler] = useState(0)
  const [expiredTripsCount, expiredTripsCountHandler] = useState(0)
  const [completedTripsCount, completedTripsCountHandler] = useState(0)
  const [archivedTripsCall, archivedTripsCallHandler] = useState(false)
  const [data, setDataHandler] = useState({ page: 0 })
  const [tripsLoading, tripsLoadingHandler] = useState(true)
  const [paginatedLoading, paginatedLoadingHandler] = useState(false)
  const [tripsLoadingFailed, tripsFailedHandler] = useState(false)
  const [allUpcomingTrips, updateUpcomingTripsHandler] = useState([])
  const [allPastTrips, updatePastTripsHandler] = useState([])
  const [lastExpiredPage, updateLastExpiredPage] = useState(0)
  const [lastCompletedPage, updateLastCompletedPage] = useState(0)
  const [lastArchivedPage, updateLastArchivedPage] = useState(0)
  const [paymentInitializedTrips, updatePaymentInitializedTrips] = useState([])
  const [piTripsFetched, updateLoaderStatus] = useState(false)
  const [showLoadMoreInUpcoming, showLoadMoreUpcomingHandler] = useState(false)
  const [showLoadMoreInCompleted, showLoadMoreCompletedHandler] = useState(false)
  const [pollComplete, setPollCompleteFlag] = useState(false)
  const [reorderComplete, setReorderCompleteFlag] = useState(false)

  // const checkAuthorization = () => {
  //   const ctAuthNoLogin = readCookie('ct-auth-no-login')
  //   return (ctAuthNoLogin !== null && ctAuthNoLogin !== undefined
  // && ctAuthNoLogin !== 'null') || checkUserLogin()
  // }

  let upcomingTripsFirstCall = []
  const fetchAllTrips = apiData => {
    tripsLoadingHandler(true)
    if (checkUserLogin()) {
      httpAxios(FETCH_TRIPS_URL, POST_CALL, apiData)
        .then(res => {
          if (res.data.upcomingTrips && res.data.expiredTrips) {
            tripsLoadingHandler(false)
            tripsFailedHandler(false)
            let upcomingTrips = []
            let expiredTrips = []
            let archivedTrips = []
            if (res.data.upcomingTrips &&
              res.data.upcomingTrips.tripListResponses &&
              res.data.upcomingTrips.tripListResponses.length) {
              upcomingTrips = res.data.upcomingTrips.tripListResponses
              upcomingTripsFirstCall = [...upcomingTrips]
              upcomingTrips.sort((trip1, trip2) => {
                const t1 = new Date(convertToSafariCompatibleDate(trip1.travelDate))
                const t2 = new Date(convertToSafariCompatibleDate(trip2.travelDate))
                return t1 - t2
              })
              upcomingTripsCountHandler(upcomingTrips.length)
            }

            if (apiData.firstCall && (!upcomingTrips.length || upcomingTrips.length <= 5)) {
              tripsLoadingHandler(true)
              setDataHandler({ page: 1 })
              fetchAllTrips({
                firstCall: false,
                pageSize: 10,
                pageNo: 0,
                tripStatus: 'expiredCompleted'
              })
            }

            if (res.data.expiredTrips &&
              res.data.expiredTrips.tripListResponses &&
              res.data.expiredTrips.tripListResponses.length) {
              expiredTrips = res.data.expiredTrips.tripListResponses
            }

            if (res.data.expiredTrips && res.data.expiredTrips.tripListResponses &&
              res.data.expiredTrips.tripListResponses.length &&
              res.data.expiredTrips.tripListResponses.length <=
              res.data.expiredTrips.totalElements &&
              apiData.tripStatus === 'expiredCompleted') {
              setDataHandler({ page: 1 })
              archivedTripsCallHandler(false)
            }

            if (res.data.expiredTrips && res.data.expiredTrips.tripListResponses &&
              res.data.expiredTrips.tripListResponses.length === 0 && apiData.tripStatus === 'expiredCompleted') {
              tripsLoadingHandler(true)
              setDataHandler({ page: 1 })
              fetchAllTrips({
                firstCall: false,
                pageSize: 10,
                pageNo: 0,
                tripStatus: 'archived'
              })
            }

            if (res.data.archivedTrips &&
              res.data.archivedTrips.tripListResponses &&
              res.data.archivedTrips.tripListResponses.length) {
              archivedTrips = res.data.archivedTrips.tripListResponses
            }

            let tripsData = [...upcomingTrips, ...expiredTrips, ...archivedTrips]
            if (upcomingTripsFirstCall.length) {
              tripsData = [...upcomingTripsFirstCall, ...expiredTrips, ...archivedTrips]
            }
            // const trips = upcoming_trips;
            updateTripsHandler(tripsData)
          } else {
            tripsLoadingHandler(false)
            tripsFailedHandler(true)
          }
        })
        .catch(err => {
          if (err && err.response && err.response.status === 401) {
            navigateToExternalLink(`${UNAUTHORIZED_REDIRECT}`)
          }
          tripsLoadingHandler(false)
          tripsFailedHandler(true)
        })
    } else {
      navigateToExternalLink(`${UNAUTHORIZED_REDIRECT}`)
    }
  }

  const fetchTripsForDesktop = (apiData, flag) => {
    if (!flag && apiData.pageNo === 0) {
      tripsLoadingHandler(true)
    } else {
      paginatedLoadingHandler(true)
    }
    if (checkUserLogin()) {
      httpAxios(FETCH_TRIPS_URL, POST_CALL, apiData)
        .then(res => {
          if (res.data.upcomingTrips && res.data.expiredTrips) {
            let upcomingTrips = []
            let expiredTrips = []
            let archivedTrips = []
            if (res.data.upcomingTrips &&
              res.data.upcomingTrips.tripListResponses &&
              res.data.upcomingTrips.tripListResponses.length) {
              upcomingTrips = res.data.upcomingTrips.tripListResponses
              let piCount = 0
              for (const piTrip of upcomingTrips) {
                if (piTrip.bookingStatus === 'payment initialized' || piTrip.bookingStatus === 'payment failed') {
                  piCount += 1
                }
              }
              if (piCount !== 0) {
                updateLoaderStatus(true)
              }
              upcomingTripsCountHandler(upcomingTrips.length)
            }
            if (res.data.expiredTrips &&
              res.data.expiredTrips.tripListResponses &&
              res.data.expiredTrips.tripListResponses.length) {
              expiredTrips = res.data.expiredTrips.tripListResponses
              const page = Math.ceil(res.data.expiredTrips.totalElements / apiData.pageSize, 10)
              updateLastExpiredPage(page - 1)
            }

            if (res.data.archivedTrips &&
              res.data.archivedTrips.tripListResponses &&
              res.data.archivedTrips.tripListResponses.length) {
              archivedTrips = res.data.archivedTrips.tripListResponses
              const page = Math.ceil(res.data.archivedTrips.totalElements / apiData.pageSize, 10)
              updateLastArchivedPage(page - 1)
            }
            tripsLoadingHandler(false)
            tripsFailedHandler(false)
            const tripsData = [...allUpcomingTrips, ...upcomingTrips]
            tripsData.sort((trip1, trip2) => {
              const t1 = new Date(convertToSafariCompatibleDate(trip1.travelDate))
              const t2 = new Date(convertToSafariCompatibleDate(trip2.travelDate))
              return t1 - t2
            })
            updateUpcomingTripsHandler(tripsData)
            const ptripsData = [...allPastTrips, ...expiredTrips, ...archivedTrips]
            updatePastTripsHandler(ptripsData)
          } else {
            tripsLoadingHandler(false)
            paginatedLoadingHandler(false)
            tripsFailedHandler(true)
          }
        })
        .catch(err => {
          if (err && err.response && err.response.status === 401) {
            navigateToExternalLink(`${UNAUTHORIZED_REDIRECT}`)
          }
          tripsLoadingHandler(false)
          paginatedLoadingHandler(false)
          tripsFailedHandler(true)
        })
    } else {
      navigateToExternalLink(`${UNAUTHORIZED_REDIRECT}`)
    }
  }

  /*
    Trip list API changed to fetch upcoming, expired, completed and archived trips
    The payload is of type -
      pageNo: 0
      pageSize: 5
      tripStatus: "upcoming"
      and response return for the corresponding trip status
      {
        "upcomingTrips":
        {
          "totalElements":10,
          "tripListResponses":[]
        }
      }
  */
  let openTrips = []
  let apiCounter = 0
  const fetchTriplistForDesktop = (apiData, status) => {
    apiCounter += 1
    if (status === 'upcoming' && apiData.pageNo === 0) {
      tripsLoadingHandler(true)
    } else {
      paginatedLoadingHandler(true)
    }
    if (checkUserLogin()) {
      httpAxios(FETCH_TRIPS_URL, POST_CALL, apiData)
        .then(res => {
          if (res.data.upcomingTrips && res.data.expiredTrips) {
            apiCounter -= 1
            paginatedLoadingHandler(false)
            let upcomingTrips = []
            let completedTrips = []
            let archivedTrips = []
            if (res.data.upcomingTrips &&
              res.data.upcomingTrips.tripListResponses &&
              res.data.upcomingTrips.tripListResponses.length) {
              upcomingTrips = res.data.upcomingTrips.tripListResponses
              let piCount = 0
              for (const piTrip of upcomingTrips) {
                if (piTrip.bookingStatus === 'payment initialized' || piTrip.bookingStatus === 'payment failed') {
                  piCount += 1
                }
              }
              if (piCount !== 0) {
                updateLoaderStatus(true)
              }
              upcomingTripsCountHandler(upcomingTrips.length)
            }

            if (res.data.expiredTrips &&
              res.data.expiredTrips.tripListResponses &&
              res.data.expiredTrips.tripListResponses.length) {
              openTrips = [...openTrips, ...res.data.expiredTrips.tripListResponses]
              expiredTripsCountHandler(res.data.expiredTrips.totalElements)
              const page = Math.ceil(res.data.expiredTrips.totalElements / apiData.pageSize, 10)
              updateLastExpiredPage(page - 1)
            }

            upcomingTrips.sort((trip1, trip2) => {
              const t1 = new Date(convertToSafariCompatibleDate(trip1.travelDate))
              const t2 = new Date(convertToSafariCompatibleDate(trip2.travelDate))
              return t1 - t2
            })

            const updatedUpcomingTrips = []
            for (const upTrip of upcomingTrips) {
              if (['payment failed', 'cancelled', 'refunded', 'booking failed'].indexOf(upTrip.bookingStatus) > -1) {
                openTrips.push(upTrip)
              } else {
                updatedUpcomingTrips.push(upTrip)
              }
            }

            openTrips.sort((trip1, trip2) => {
              const t1 = new Date(convertToSafariCompatibleDate(trip1.travelDate))
              const t2 = new Date(convertToSafariCompatibleDate(trip2.travelDate))
              return t2 - t1
            })

            let tripsData = [...allUpcomingTrips, ...updatedUpcomingTrips, ...openTrips]

            if (res.data.completedTrips &&
              res.data.completedTrips.tripListResponses &&
              res.data.completedTrips.tripListResponses.length) {
              completedTrips = res.data.completedTrips.tripListResponses
              completedTripsCountHandler(res.data.completedTrips.totalElements)
              const pageNo = Math.ceil(res.data.completedTrips.totalElements / apiData.pageSize, 10)
              updateLastCompletedPage(pageNo - 1)
            }

            if (res.data.completedTrips &&
              res.data.completedTrips.tripListResponses &&
              res.data.completedTrips.tripListResponses.length === 0 &&
              status === 'completed' && apiData.pageNo !== 1) {
              const archivedPayload = {
                pageSize: 10,
                pageNo: 0,
                tripStatus: 'archived'
              }
              archivedTripsCallHandler(true)
              fetchTriplistForDesktop(archivedPayload, 'archived')
            }

            if (res.data.archivedTrips &&
              res.data.archivedTrips.tripListResponses &&
              res.data.archivedTrips.tripListResponses.length) {
              archivedTrips = res.data.archivedTrips.tripListResponses
              const page = Math.ceil(res.data.archivedTrips.totalElements / apiData.pageSize, 10)
              updateLastArchivedPage(page - 1)
            }

            const pTripsData = [...allPastTrips, ...completedTrips, ...archivedTrips]
            pTripsData.sort((trip1, trip2) => {
              const t1 = new Date(convertToSafariCompatibleDate(trip1.travelDate))
              const t2 = new Date(convertToSafariCompatibleDate(trip2.travelDate))
              return t2 - t1
            })

            if (status === 'upcoming') {
              upcomingTripsFirstCall = [...updatedUpcomingTrips]
              updateUpcomingTripsHandler(updatedUpcomingTrips)
              if (upcomingTripsFirstCall.length) {
                upcomingTripsFirstCall[0].firstExpiredTripFlag = true
                upcomingTripsFirstCall[0].categoryHeader = getMappedValue('upcoming trips')
              }
              const expiredPayload = {
                pageSize: 10,
                pageNo: 0,
                tripStatus: 'expired'
              }
              fetchTriplistForDesktop(expiredPayload, 'expired')
            } else if (status === 'expired') {
              if (openTrips.length && apiData.pageNo === 0) {
                openTrips[0].firstExpiredTripFlag = true
                openTrips[0].categoryHeader = getMappedValue('Cancelled and Payment Failed Trips')
              }
              if (upcomingTripsFirstCall.length) {
                tripsData = [...upcomingTripsFirstCall, ...openTrips]
              }
              tripsData = makeArrayUnique(tripsData, 'tripId')
              updateUpcomingTripsHandler(tripsData)
            } else if (status === 'completed' || status === 'archived') {
              updatePastTripsHandler(pTripsData)
            }

            if (apiCounter === 0) {
              tripsLoadingHandler(false)
              tripsFailedHandler(false)
            }
          }
        })
        .catch(err => {
          if (err && err.response && err.response.status === 401) {
            navigateToExternalLink(`${UNAUTHORIZED_REDIRECT}`)
          }
          tripsLoadingHandler(false)
          paginatedLoadingHandler(false)
          tripsFailedHandler(true)
        })
    } else {
      navigateToExternalLink(`${UNAUTHORIZED_REDIRECT}`)
    }
  }

  const piTrips = {}
  let piTripsCount = 0
  let piRequestsCount = 0
  const fetchStatus = tripId => {
    const fetchUrl = `${POLL_STATUS}/${tripId}`
    piRequestsCount += 1
    httpAxios(fetchUrl, GET_CALL)
      .then(res => {
        if (res.data) {
          const newTrips = { ...piTrips }
          if (Object.keys(newTrips).indexOf(tripId) < 0) {
            newTrips[tripId] = res.data
            piTrips[tripId] = res.data
            updatePaymentInitializedTrips(newTrips)
            piTripsCount += 1
            if (piTripsCount === piRequestsCount) {
              updateLoaderStatus(false)
              setPollCompleteFlag(true)
            }
          }
        }
      })
      .catch(err => {
        // console.log(err)
      })
  }

  const reorderTrips = (allTrips, polledTrips) => {
    const allTripsBeforePoll = [...allTrips]
    const newUpcoming = []
    const newOpen = []
    for (const upTrip of allTripsBeforePoll) {
      if (polledTrips[upTrip.tripId]) {
        upTrip.bookingStatus = polledTrips[upTrip.tripId].status
        upTrip.travellers = polledTrips[upTrip.tripId].msg
      }
      if (['payment failed', 'cancelled', 'refunded', 'booking failed'].indexOf(upTrip.bookingStatus) > -1) {
        newOpen.push(upTrip)
      } else {
        newUpcoming.push(upTrip)
      }
      if (upTrip.firstExpiredTripFlag) {
        upTrip.firstExpiredTripFlag = false
        delete upTrip.categoryHeader
      }
    }
    if (newUpcoming.length) {
      newUpcoming[0].categoryHeader = 'Upcoming Trips'
    }

    if (newOpen.length) {
      newOpen.sort((trip1, trip2) => {
        const t1 = new Date(convertToSafariCompatibleDate(trip1.travelDate))
        const t2 = new Date(convertToSafariCompatibleDate(trip2.travelDate))
        return t2 - t1
      })
      newOpen[0].firstExpiredTripFlag = true
      newOpen[0].categoryHeader = 'Cancelled and Payment Failed Trips'
    }
    const tripsData = [...newUpcoming, ...newOpen]
    updateUpcomingTripsHandler(tripsData)
  }

  return (
    <TripListContext.Provider
      value={{
        trips,
        expiredTripsCount,
        fetchAllTrips,
        tripsLoading,
        tripsLoadingFailed,
        updateTripsHandler,
        upcomingTripsCount,
        fetchTripsForDesktop,
        allPastTrips,
        allUpcomingTrips,
        paginatedLoading,
        lastExpiredPage,
        lastCompletedPage,
        lastArchivedPage,
        fetchStatus,
        paymentInitializedTrips,
        piTripsFetched,
        completedTripsCount,
        archivedTripsCall,
        archivedTripsCallHandler,
        fetchTriplistForDesktop,
        showLoadMoreInUpcoming,
        showLoadMoreUpcomingHandler,
        showLoadMoreInCompleted,
        showLoadMoreCompletedHandler,
        data,
        setDataHandler,
        reorderTrips,
        pollComplete,
        reorderComplete,
        setReorderCompleteFlag
        // piReqestsMade
      }}
    >
      {children}
    </TripListContext.Provider>
  )
}
